import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { notification } from 'antd';
import { api } from '@seaoil/component-lib';

import AsyncAutoComplete from './AsyncAutoComplete';

const { mySEAOIL } = api;

function COAField({
  // attributes
  placeholder,
  disabled,

  // object attributes
  config: { viewName, companyCode, isItem },

  // methods
  onInputSelect,
}) {
  const [segments, setSegments] = useState([]);
  const [loading, isLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const retryLimit = 5;
  let retryCount = 0;

  const loadSegments = async () => {
    isLoading(() => true);
    try {
      const segs = await mySEAOIL.datawarehouse.view({
        viewName,
        schema: 'erp',
        filters: (() => {
          const output = [];
          if (companyCode !== undefined) {
            output.push({
              key: isItem !== undefined ? 'subsidiary_id' : 'subsidiary_code',
              operation: Buffer.from('=').toString('base64'),
              value: companyCode,
            });
          }
          output.push({
            key: 'enabled',
            operation: Buffer.from('=').toString('base64'),
            value: 'Y',
          });
          return output;
        })(),
        orderBy: [{
          field: 'description',
          value: 'ASC',
        }],
        limit: 15000,
      }).send();
      setSegments(segs.records);
    } catch (e) {
      if (retryCount > retryLimit) {
        notification.error({ message: `Unable to load ${viewName} after multiple retries. Kindly contact supportdesk@seaoil.com.ph` });
      } else {
        notification.error({ message: `Unable to load ${viewName}. Retrying after 2 seconds...` });
        setTimeout(loadSegments, 2000);
        retryCount += 1;
      }
    } finally {
      isLoading(() => false);
    }
  };

  useEffect(() => {
    loadSegments();
  }, []);

  useEffect(() => {
    if (!Array.isArray(segments)) {
      return;
    }

    setOptions(segments.map(({
      description,
    }) => ({
      value: description,
      label: description,
    })));
  }, [segments]);

  return (
    <AsyncAutoComplete
      placeholder={placeholder}
      loading={loading}
      disabled={disabled}
      options={options}
      onInputSelect={(description) => {
        if (segments) {
          onInputSelect(segments.find((seg) => seg.description === description));
        }
      }}
    />
  );
}

COAField.propTypes = {
  placeholder: PropTypes.string.isRequired,
  disabled: PropTypes.string.isRequired,
  config: PropTypes.instanceOf(Array).isRequired,
  onInputSelect: PropTypes.string.isRequired,
};

export default COAField;
